// extracted by mini-css-extract-plugin
module.exports = {"heading":"customer-list-column_heading__GYHqP"};